export default __webpack_public_path__ + "static/media/termsImageTablet.8260c3ed.png";